import React, { PureComponent } from "react";
import { Modal } from "antd";
import PropTypes from "prop-types";
import "../../assets/stylus/com/feedback/modal.styl";
import { closeModals } from "../../state/action/comAction";

class scModal extends PureComponent {
  constructor(props) {
    super();
    this.props = props;
  }

  static contextTypes = {
    store: PropTypes.object.isRequired,
  };

  componentWillMount() {
    this.initStore();
  }

  initStore() {
    const store = this.context.store;
    store.subscribe(() => {
      if (
        this.context.store.getState().modalInfo.key === this.props.config.key
        && this.context.store.getState().modalInfo.render
      ) {
        this.refreshStore(store);
      }
    });
  }

  refreshStore(store) {
    const modalInfo = store.getState().modalInfo;
    this.setState({
      visible: modalInfo.visible,
      param: modalInfo.param,
      fetchParams: modalInfo.fetchParams,
      context: modalInfo.context,
    });
  }

  onCancel = () => {
    this.context.store.dispatch(closeModals());
  }

  render() {
    console.log(this.state);
    return (
      this.context.store.getState().modalInfo.key === this.props.config.key
      && this.context.store.getState().modalInfo.visible && (
        <Modal
          width={this.props.config.width}
          title={this.props.config.title}
          visible={this.state.visible}
          onCancel={this.onCancel}
          wrapClassName='vertical-center-modal'
          footer={null}
          // confirmLoading={this.props.confirmLoading}
        >
          {this.props.config.content}
        </Modal>
      )
    );
  }
}

export default scModal;

scModal.propsType = {
  config: PropTypes.object,
};



// WEBPACK FOOTER //
// ./src/AntD/components/feedback/scModalCore.js